"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveOptions = void 0;
const defaultOptions = {
    format: 'json',
    level: 'info',
};
const resolveOptions = (options) => {
    const envFormat = process.env['MIRO_LOGGING_FORMAT'];
    const envLevel = process.env['MIRO_LOGGING_LEVEL'];
    const format = envFormat || (options === null || options === void 0 ? void 0 : options.format) || defaultOptions.format;
    const level = envLevel || (options === null || options === void 0 ? void 0 : options.level) || defaultOptions.level;
    return { format, level, context: options === null || options === void 0 ? void 0 : options.context };
};
exports.resolveOptions = resolveOptions;
//# sourceMappingURL=utils.js.map